module.exports = __webpack_public_path__ + "img/banner.848883df.png";